module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/google-play-564.f708bc6c976ed07a.png"+" 564w",
        images: [{path: "https://static.sniffspot.com/packs/img/google-play-564.f708bc6c976ed07a.png",width: 564,height: 168}],
        src: "https://static.sniffspot.com/packs/img/google-play-564.f708bc6c976ed07a.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/google-play-564.f708bc6c976ed07a.png"},
        
        width: 564,
        height: 168
      }